import React, { Component } from 'react';

export class Footer extends Component {
    static displayName = Footer.name;

    constructor(props) {
        super(props);

        this.year = new Date().getFullYear();
    }

    render() {
        return (
            <div className="container">
                <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
                    <div className="col-md-4 d-flex align-items-center">
                        <span className="text-muted">&copy; {this.year} Health First, Inc</span>
                    </div>
                    {/*<ul class="nav col-md-4 justify-content-end list-unstyled d-flex">*/}
                    {/*    <li class="ms-3"><a class="text-muted" href="#"><svg class="bi" width="24" height="24"><use xlink:href="#twitter" /></svg></a></li>*/}
                    {/*    <li class="ms-3"><a class="text-muted" href="#"><svg class="bi" width="24" height="24"><use xlink:href="#instagram" /></svg></a></li>*/}
                    {/*    <li class="ms-3"><a class="text-muted" href="#"><svg class="bi" width="24" height="24"><use xlink:href="#facebook" /></svg></a></li>*/}
                    {/*</ul>*/}
                </footer>
            </div>
        );
    }
}